function _getEnv() {
  console.log(process.env.DP_ENV, '---DP_ENV---')
  return process.env.DP_ENV || 'dev'
}
const isGrayProd = ['gray', 'prod'].includes(_getEnv().toLowerCase())
export const DC_APP_ID_SECREAT = {
  APP_ID: isGrayProd ? 'efd4168edcce44e5abdeeff63995ab34' : 'bd8d27dedf714161b685f5b40ba73b82',
  APP_SECREAT: isGrayProd ? '9d9c24a77d52457c93c934543688b196' : '8cc34b5293074fe3bd978f205eb03427'
}


// WEBPACK FOOTER //
// ./src/common/util/config.js